import { Box, BoxProps } from "@mui/material";
import { FC } from "react";

export const ContractText: FC<BoxProps> = ({ children, ...props }) => {
  return (
    <Box
      {...props}
      sx={{
        ...props.sx,
        height: "100%",
        px: 6,
        py: 4,
        overflow: "auto",
        direction: "rtl",
      }}
    >
      <Box
        sx={{
          direction: "ltr",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          gap: 2,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
